import { connect } from 'react-redux';

import SegmentContainer from '../../components/segment/Container';
import {
  getLocation,
  getPreviousLocation,
  getSelectedSegment,
  getTenantId,
} from '../../reducers/analyticsApp';

const mapStateToProps = (state) => {
  const selectedSegment = getSelectedSegment(state);
  const previousLocation = getPreviousLocation(state) || '';
  const location = getLocation(state);
  const tenantId = getTenantId(state);

  const isSegmentsTabOpen =
    selectedSegment && !previousLocation.includes('segments') && location.includes('segments');

  return {
    isSegmentsTabOpen,
    selectedSegment,
    tenantId,
  };
};

export default connect(mapStateToProps)(SegmentContainer);
